window.addEventListener('searchspring.domReady', function () { 
  // add complete the look input to product card form.
  const productCards = document.querySelectorAll('.ss__result');

  [...productCards].forEach(element => {
    const productURL = element.querySelector('.component-image__wrapper')?.href;
    const elementForm = element.querySelector('[action="/cart/add"]');
    const inputs = [...elementForm.querySelectorAll('[name="properties[_upsell_data]"], [name="properties[_upsell_block_title]"]')];

    if(!!inputs.length) return;
    if(!productURL) return;

    try {
      fetch(productURL)
      .then(data => data.text())
      .then(data => {
        if(!data) return;
        const div = document.createElement('div');
        div.innerHTML = data;
  
        const _upsell_inputs = [...div.querySelectorAll('[name="properties[_upsell_data]"], [name="properties[_upsell_block_title]"]')];

        if(!_upsell_inputs.length) return;
        //console.log('productURL', productURL, '_upsell_inputs', _upsell_inputs,'elementForm', elementForm )
        _upsell_inputs.forEach(input => {
          elementForm?.appendChild(input);
        })
        
      }).catch(err => console.error("Error on fetching product"));
    } catch(err) {
      console.error("Error on fetching product")
    }
  })
}, false);
window.addEventListener('searchspring-side-cart-recs.domReady', function () { 
  console.log('sideCartRecs domReady');
  console.log([...document.querySelectorAll('[searchspring-recommend="mini-cart-recommendations"] .cart__upsell-info .btn')]);
  document.addEventListener('click', function(e) {
    const targetBtn = e.target.closest('[searchspring-recommend="mini-cart-recommendations"] .cart__upsell-info .btn');
    
    if (!targetBtn) {
      return;
    }
  
    const wrapper = targetBtn.closest('.cart__upsell-item');
    const productURL = wrapper?.querySelector('.cart__upsell-image--wrapper')?.href;
    if(!productURL) return;
  
    fetch(productURL)
      .then(data => data.text())
      .then(data => {
        if(!data) return;
        const div = document.createElement('div');
        div.innerHTML = data;
  
        const _data = JSON.parse(div.querySelector('[type="application/json"][data-product-json-metafield]').innerHTML || '{}');
        const product = {..._data.product, color: _data.color }
        const firstAvailableVariant = product?.variants?.find(variant => variant.available);
        if(!firstAvailableVariant) return;
        if(product.variants.length > 1) {
          if(window.onSelecteUpsell) {
            window.onSelecteUpsell(product);
          }
          return;
        }
        if(window.addUpsellProductToCart) {
          window.addUpsellProductToCart(firstAvailableVariant?.id, product, firstAvailableVariant);
        }
      })
      .catch(err => {});
  });
}, false);